import client from "./_client";

export default {
  getProducts(terpenesStatus = true) {
    return client({
      method: "GET",
      url: `products?terpenes=${terpenesStatus}`
    });
  },

  getProduct(productId) {
    return client({
      method: "GET",
      url: `products/${productId}`
    });
  },

  getProductImages(productId) {
    return client({
      method: "GET",
      url: `products/${productId}/images`
    });
  },

  getProductTerpenes(productId) {
    return client({
      method: "GET",
      url: `products/${productId}/getTerpenes`
    });
  }
};
